import HeaderFullWidthLayout from './HeaderFullWidthLayout.vue';
import EmptyFullWidthLayout from './EmptyFullWidthLayout.vue';

export default {
    HeaderFullWidthLayout,
    EmptyFullWidthLayout,
};
